import o, { css } from 'styled-components';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var x=css`
  gap: 0;
`,m=css`
  gap: var(--spacing-x-small, 4px);
`,$=css`
  gap: var(--spacing-small, 8px);
`,f=css`
  gap: var(--spacing-regular, 16px);
`,y=css`
  gap: var(--spacing-large, 24px);
`,S=css`
  gap: var(--spacing-x-large, 32px);
`,A=css`
  gap: var(--spacing-x-x-large, 48px);
`,u=css`
  gap: var(--spacing-x-x-x-large, 64px);
`,n=o.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large, 24px);

  ${a=>a.$xAlign&&{"align-items":a.$xAlign}}
  ${a=>a.$yAlign&&{"justify-content":a.$yAlign}}

  ${a=>a.$spacing==="none"&&x}
  ${a=>a.$spacing==="x-small"&&m}
  ${a=>a.$spacing==="small"&&$}
  ${a=>a.$spacing==="regular"&&f}
  ${a=>a.$spacing==="large"&&y}
  ${a=>a.$spacing==="x-large"&&S}
  ${a=>a.$spacing==="x-x-large"&&A}
  ${a=>a.$spacing==="x-x-x-large"&&u}
`;var r=forwardRef(function({spacing:p="large",xAlign:i,yAlign:l,className:t,children:c,...s},e){return jsx(n,{ref:e,$spacing:p,$xAlign:i,$yAlign:l,className:t,...s,children:c})});r.displayName="Stack";var v=o(r)``;

export { v as a };
